import { useEffect, useState } from "react";
import type {
  ActivityStatus,
  ContributionDay,
  ContributionsData,
} from "../types/githubContributions";

const USERNAME = "shreyu1701";

interface RawResponse {
  total: Record<string, number>;
  contributions: ContributionDay[];
}

export function useGithubContributions(): {
  data: ContributionsData | null;
  status: ActivityStatus;
} {
  const [data, setData] = useState<ContributionsData | null>(null);
  const [status, setStatus] = useState<ActivityStatus>("loading");

  useEffect(() => {
    const controller = new AbortController();

    fetch(`https://github-contributions-api.jogruber.de/v4/${USERNAME}?y=last`, {
      signal: controller.signal,
    })
      .then((res) => {
        if (!res.ok) throw new Error(`Contributions API responded ${res.status}`);
        return res.json() as Promise<RawResponse>;
      })
      .then((json) => {
        const total = Object.values(json.total).reduce((sum, n) => sum + n, 0);
        setData({ total, days: json.contributions });
        setStatus("success");
      })
      .catch((error) => {
        if (controller.signal.aborted) return;
        console.error("Failed to load GitHub contributions", error);
        setStatus("error");
      });

    return () => controller.abort();
  }, []);

  return { data, status };
}
